const React = require("react");
function IconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.4696 7.40625c-.1756-.96216-1.0125-1.66284-1.9836-1.88159C17.0326 5.21875 14.3429 5 11.4328 5c-2.90833 0-5.64107.21875-7.09611.52466-.96946.21875-1.80805.875-1.98369 1.88159C2.17564 8.5 2 10.0313 2 12c0 1.9688.17564 3.5.39605 4.5938.17736.9621 1.01423 1.6628 1.98369 1.8815C5.9226 18.7813 8.56752 19 11.4776 19c2.9101 0 5.555-.2187 7.0979-.5247.9695-.2187 1.8063-.875 1.9837-1.8815.1756-1.0938.396-2.6695.4408-4.5938-.0895-1.9687-.31-3.5-.5304-4.59375M9.05311 15.0625v-6.125L14.4308 12z"
  }));
}
module.exports = IconYoutube;